import { createCustomEnum } from "./customEnum";

export type OriginTsKey = "application" | "merchant";

const OriginTs = createCustomEnum({
	Application: {
		name: "application",
		value: "application",
		displayName: "Application",
	},
	Merchant: { name: "merchant", value: "merchant", displayName: "Merchant" },
});

export default OriginTs;
